import React from 'react'
import {NavLink} from 'react-router-dom'
import styled from 'styled-components'
import {AccountWidget} from "./account";

const Nav: React.FC = () => {
    return (
        <StyledNav>

            <StyledLink exact activeClassName="active" to="/">
                Underwriting
            </StyledLink>
            <StyledLink exact activeClassName="active" to="/staking">
                My Portfolio
            </StyledLink>
            {/* <StyledLink activeClassName="active" to="/admin">
          admin
      </StyledLink> */}
            <StyledAbsoluteLink
                href="https://docs.nsure.network/nsure-network/nsure-underwriter-program"
                target="_blank"
            >
                Guidelines
            </StyledAbsoluteLink>
            <AccountWidget />

        </StyledNav>
    )
};

const StyledNav = styled.nav`
  align-items: center;
  display: flex;
`;

const StyledLink = styled(NavLink)`
    color: ${(props) => props.theme.color.whites[100]};
  font-weight: 700;
  padding-left: ${(props) => props.theme.spacing[3]}px;
  padding-right: ${(props) => props.theme.spacing[3]}px;
  text-decoration: none;
  &:hover {
    color: ${(props) => props.theme.color.whites[1001]};
  }
  &.active {
  
//color: #02F9FD;

background: linear-gradient(90deg, #CE45C5 0%, #5592E8 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;

  }
  @media (max-width: 768px) {
    padding-left: ${(props) => props.theme.spacing[2]}px;
    padding-right: ${(props) => props.theme.spacing[2]}px;
    font-size: 10px;

  }
`;

const StyledAbsoluteLink = styled.a`
  color: ${(props) => props.theme.color.whites[100]};
  // color: rgba(28,161,126,.5);

  font-weight: 700;
  padding-left: ${(props) => props.theme.spacing[3]}px;
  padding-right: ${(props) => props.theme.spacing[3]}px;
  text-decoration: none;
  &:hover {
       color: ${(props) => props.theme.color.c074c52};
  // color: rgba(28,161,126,.5);

  }
  &.active {
      color: ${(props) => props.theme.color.c1CA17E};
  }
 @media (max-width: 768px) {
    padding-left: ${(props) => props.theme.spacing[2]}px;
    padding-right: ${(props) => props.theme.spacing[2]}px;
    font-size: 10px;
  }
`;

export default Nav
